import {Controller} from '@stubhub/react-store-provider';

const NAMESPACE = 'user';

const controller = new Controller({
  namespace: NAMESPACE,

  mapStateToProps: (state) => {
    return {
      userName: state?.user?.primaryContact?.name?.firstName || ''
    };
  }
});

export default controller;
